import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../services/api';

export const useDeleteClientProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await api.delete('/clients/profile');
    },
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ['clientProfile'] });
    },
  });
};
